import 'typeface-reenie-beanie';
import 'typeface-assistant';

import { css, Global } from '@emotion/core';
import React from 'react';

export const wrapRootElement = () => (
  <>
    <Global
      styles={css`
        :root {
          scroll-behavior: smooth;
          min-width: 320px;
        }
        * {
          box-sizing: border-box;
        }
        body {
          margin: 0;
          font-size: 20px; 
          color: #fff;
          padding: 100px;
          text-align: center;
          background-color: #000;
        }
        img { 
          max-width: 100%;
        }
      `}
    />
    <img src="../media/logo_small.webp" alt="Grave Robbert Logo" />
    <p>
      Coming soon!
    </p>
    <p>
      In the meantime visit our shop!
    </p>
    <a href="http://graveshop.co.uk">
      <img src="../media/graveshop.png" alt="Grave Shop" />
    </a>
  </>
);
